export type BaseFilterOption = {
  text: string
  value: string
}

export const FILTER_TYPE_BASE = Symbol('__BASE__')
export const FILTER_TYPE_RANGE = Symbol('__RANGE__')
export const FILTER_TYPE_ARRAY = Symbol('__ARRAY__')
export const FILTER_TYPE_IS_READ = Symbol('__IS_READ__')
